/**
 * API Configuration
 * Environment variables loaded from:
 * - localhost: .env.development
 * - AWS Amplify: Console environment variables
 */

const baseUrl = process.env.REACT_APP_API_BASE_URL?.trim();
const adminBaseUrl = process.env.REACT_APP_ADMIN_API_BASE_URL?.trim();

if (!baseUrl) {
  throw new Error(
    'REACT_APP_API_BASE_URL environment variable is required'
  );
}

export const apiConfig = {
  baseUrl,
  adminBaseUrl: adminBaseUrl || baseUrl, // Fallback to baseUrl if not provided
  endpoints: {
    getQuickSightEmbedUrl: '/get-embed-url',
    getUserDashboards: '/quicksight/dashboards',
    adminUsers: '/admin/users',
    adminUserActivity: '/admin/user-activity',
  },
  timeout: 30000
};

export default apiConfig;
